/**
 * maneno-web-kit PostHog helper — Maneno LMS vs Griffin LMS
 * Host: https://posthog.maneno.dk
 */
import posthog from "posthog-js";

type LmsBrand = "maneno_lms" | "griffin_lms";

const KEYS: Record<LmsBrand, string | undefined> = {
  maneno_lms: process.env.REACT_APP_POSTHOG_KEY_MANENO_LMS,
  griffin_lms: process.env.REACT_APP_POSTHOG_KEY_GRIFFIN_LMS
};

const HOST = process.env.REACT_APP_POSTHOG_HOST || "https://posthog.maneno.dk";

export function resolveLmsBrand(
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
  pathname = typeof window !== "undefined" ? window.location.pathname : ""
): LmsBrand {
  const h = hostname.toLowerCase();
  const p = pathname.toLowerCase();
  if (h.includes("griffle") || h.includes("griffin") || h.includes("readgriffin") || p.startsWith("/griffle")) {
    return "griffin_lms";
  }
  return "maneno_lms";
}

let started = false;
let startedBrand: LmsBrand | null = null;

export function initPostHog(opts?: { consentGiven?: boolean; brand?: LmsBrand }) {
  const brand = opts?.brand || resolveLmsBrand();
  if (started && startedBrand === brand) return;

  // Re-init if brand changed (e.g. navigated into /griffle)
  if (started && startedBrand !== brand) {
    posthog.reset();
    started = false;
  }

  const apiKey = KEYS[brand];
  if (!apiKey || apiKey.includes("REPLACE")) {
    console.warn("[posthog] missing key for LMS brand", brand);
    return;
  }

  posthog.init(apiKey, {
    api_host: HOST,
    capture_pageview: false,
    persistence: "localStorage+cookie",
    opt_out_capturing_by_default: true
  });
  posthog.register({
    platform: "web",
    app_flavor: brand,
    product: brand === "griffin_lms" ? "griffin_lms" : "maneno_lms"
  });
  if (opts?.consentGiven !== false) {
    posthog.opt_in_capturing();
  }
  started = true;
  startedBrand = brand;
}

export function identifyUser(userId: string, props?: Record<string, unknown>) {
  if (!started) return;
  posthog.identify(String(userId), props);
}

export function capture(event: string, props?: Record<string, unknown>) {
  if (!started) return;
  posthog.capture(event, props);
}

export function isPostHogStarted() {
  return started;
}
